import { call, put, takeEvery } from "redux-saga/effects"

import { GET_SCHEDULED_LIST, GET_SCHEDULED_DETAIL, CANCEL_SCHEDULED, FREEZE_SCHEDULED } from "./actionTypes"

import {
  getScheduledListSuccess,
  getScheduledListFail,
  getScheduledDetailSuccess,
  getScheduledDetailFail,
  cancelScheduledSuccess,
  cancelScheduledFail,
  freezeScheduledSuccess,
  freezeScheduledFail,
} from "./actions"

import {
  getScheduledData,
  getScheduledDetail,
  cancelScheduledData,
  freezeScheduledData,
} from "../../helpers/scheduled_helper"

function* fetchScheduledList({ payload }) {
  try {
    const response = yield call(getScheduledData, payload)
    yield put(getScheduledListSuccess(response))
  } catch (error) {
    yield put(getScheduledListFail(error))
  }
}

function* fetchScheduledDetail({ payload: id }) {
  try {
    const response = yield call(getScheduledDetail, id)
    yield put(getScheduledDetailSuccess(response))
  } catch (error) {
    yield put(getScheduledDetailFail(error))
  }
}

function* onCancelScheduled({ payload: id }) {
  try {
    yield call(cancelScheduledData, id)
    yield put(cancelScheduledSuccess(id))
  } catch (error) {
    yield put(cancelScheduledFail(error))
  }
}

function* onFreezeScheduled({ payload: id }) {
  try {
    const response = yield call(freezeScheduledData, id)
    yield put(freezeScheduledSuccess(response))
  } catch (error) {
    yield put(freezeScheduledFail(error))
  }
}

function* scheduledSaga() {
  yield takeEvery(GET_SCHEDULED_LIST, fetchScheduledList)
  yield takeEvery(GET_SCHEDULED_DETAIL, fetchScheduledDetail)
  yield takeEvery(CANCEL_SCHEDULED, onCancelScheduled)
  yield takeEvery(FREEZE_SCHEDULED, onFreezeScheduled)
}

export default scheduledSaga
